import React, { Component } from "react";
import Checkbox from "./Checkbox";

class TableHeaderCellSelection extends Component {
  render() {
    return (
      <th
        className="dnd-table-header-cell"
        style={{ textAlign: "center", width: "5%", minWidth: 35 }}>
        <Checkbox
          isIndeterminate={this.props.isIndeterminate}
          checked={this.props.checked}
          onChange={this.props.onClickHeaderSelect}
        />
      </th>
    );
  }
}

export default TableHeaderCellSelection;
